export default __webpack_public_path__ + "static/media/fine.7e14039e.jpg";